import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { borderRadius, boxSizing, display, fontSize, fontWeight, minWidth } from '@mui/system';
import { dark } from 'styles/theme';
import { thirdly } from 'styles/theme';

export const AffiliationsExecutionStyles = muiStyled(Box)(({ showSegmentation, affiliationLength, showLegend, color, theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    background: "white",
    padding: "15px 35px",
    flexGrow: 1,
    borderRadius: 15,
    display: "flex",
    flexDirection: "column",
    rowGap: 10,
    '.percentage-items': {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        rowGap: 15
    },
    '.short-item': {
        width: 38,
        flex: "none !important"
    },
    '.contnet': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        flexGrow: 1,
        overflow: "auto",
    },
    '.footer': {
        // height: 60
    },
    '.affiliations-loading': {
        display: "flex",
        height: 200,
        alignItems: "center",
        justifyContent: "center"
    },
    '.affiliation-details': {
        width: 200,
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        rowGap: 3,
        color: dark,
        paddingLeft: 20,
        alignItems: "flex-end"
    },
    '.summary': {
        width: 170,
        display: "flex",
        justifyContent: "center",
        color: dark,
        alignItems: "center"
    },
    '.percentage-data': {
        display: "flex",
        justifyContent: "space-between",
        // direction: "rtl",
        columnGap: 10,
        // width: "85%",
        // flexDirection: "column",
        rowGap: 20
    },
    '.wrap-percentages': {
        flexGrow: 1,
        // direction: "rtl",
        display: "flex",
        justifyContent: "end"
    },
    '.percentages': {
        width: showSegmentation ?
            (affiliationLength > 5 ? "calc(100% - 57px)" : "calc(100% - 57px)") :
            affiliationLength > 5 ? "calc(100% - 20px)" : "100%",
        display: "flex",
        justifyContent: "space-between",
    },
    '.percentage-bg-bold': {
        color: showLegend && thirdly
    },
    '.percentage-bold': {
        fontWeight: showLegend && "bold"
    },
    '.percentage-short': {
        width: 30
    },
    '.line': {
        background: "#E2E3E3",
        height: 1,
        width: "100%"
    },
    '.bold-line': {
        background: showLegend && thirdly,
        height: showLegend && 2
    },
    '.bar-lines': {
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        rowGap: affiliationLength > 2 ? 8 : 20
    },
}));

export const ExecutionExplanationTooltipStyles = muiStyled(Box)(({ showSegmentation, affiliationLength, showLegend, color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: 5,
    padding: 5,
    '.title': {
        fontWeight: "bold"
    },
    '.content': {

    }
}));

export const BarLineExecutionStyles = muiStyled(Box)(({ isLearningCenter, executionPercentage, showLegend, color, theme }) => ({
    direction: "rtl",
    textAlign: "end",
    display: "flex",
    height: 40,
    flexGrow: 1,
    background: "#F2F4F7",
    '.assessment-execution-line': {
        display: "flex",
        justifyContent: "space-between", /* Aligns children to the start and end */
        background: thirdly,
        columnGap: 4,
        width: executionPercentage + "%",
        // minWidth: 100,
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        padding: executionPercentage ? 10 : 0,
        boxSizing: "border-box",
        display: "flex",
        flexWrap: "wrap"
    },
}));


export const FooterStyles = muiStyled(Box)(({ showLegend, color, theme }) => ({
    display: "flex",
    // columnGap: 70,
    // direction: "rtl",
    width: "100%",
    overflowX: "auto",
    '.selected-icon': {
        height: 20,
        marginBottom: 5
    },
    '.date-item': {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "end"
    },
    '.MuiSvgIcon-root': {
        transform: "rotate(90deg)",
        fontSize: 19
    },
    '.border-line': {
        height: 1,
        width: 200,
        background: "#E2E3E3",
    },
    '.selected-line': {
        height: 2,
        background: dark
    },
    '.MuiButtonBase-root.MuiButton-root': {
        minWidth: "auto",
        width: "100%"
    }
}));

const AssessmentExecutionTrackingStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "auto",
    rowGap: 20,
    '.header': {
        display: "flex",
        flexDirection: "column"
    },
    '.tabs': {
        padding: "0px 8px",
    },
    '.note': {
        background: "#F5F9FF",
        border: `1px solid ${thirdly}`,
        borderRadius: 8,
        padding: "15px 25px",
        display: "flex",
        flexDirection: "column",
        rowGap: 5,
        width: 820
    },
    '.note-title': {
        fontWeight: "bold",
        color: thirdly
    },
    '.view-type-btns': {
        height: 43,
        display: "flex",
        justifyContent: "flex-end"
    },
    '.bar-data': {
        flexGrow: 1,
        overflow: "auto",
        background: "white",
        flexGrow: 1,
        borderRadius: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 30
    }
}));


const BarItemStyles = muiStyled(Box)(({ hideDetails, color, theme }) => ({
    display: "flex",
    // direction: "rtl",
    columnGap: 10,
    boxSizing: "border-box",
    '.summary-item': {
        background: "#E6F0FE",
        borderRadius: 5,
        fontSize: 16,
        height: 38,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 110,
        flexDirection: "column",
        padding: 5
    },
    '.number-and-hebrew-text': {
        display: "flex",
        columnGap: 4
    },
    '.bold': {
        fontWeight: "bold"
    },

    '.affiliation-title': {
        fontWeight: "bold"
    },
    '.bar-line': {
        display: "flex",
        flexGrow: 1,
        // border: `1px solid #CAD3DF`
    },

    ".hebrew-text, .number": {
        whiteSpace: "nowrap" /* מונע מהטקסט להתפרס בשורה אחת */
    }
}));

export { AssessmentExecutionTrackingStyles, BarItemStyles }
